import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import customStyles from "../../../customStyles";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";
import { getPerformanceChartRequest } from "../../../utils/apis/accountsApi";
import RoundedBarChart from "./RoundedBarChart";
import "./style.scss";
function TradeReports({ loginId }) {
  const options = [
    { value: null, label: "Overall" },
    { value: "True", label: "Active" },
    { value: "False", label: "Inactive" },
  ];
  const options2 = [
    { value: null, label: "Trade Duration" },
    { value: "True", label: "Active" },
    { value: "False", label: "Inactive" },
  ];

  const [performanceChart, setPerformanceChart] = useState([]);
  const { idToken } = useSelector((state) => state?.auth);
  const { login_id } = useSelector((state) => state?.accountList);
  const [loading, setLoading] = useState(false);

  const fetchPerformanceChartData = async () => {
    setLoading(true);
    try {
      if (login_id !== null || loginId) {
        const response = await getPerformanceChartRequest(
          idToken,
          login_id || loginId
        );
        setPerformanceChart(response);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPerformanceChartData();
  }, [login_id || loginId, idToken]);



  const performance_trade = {
    data: performanceChart?.performance_by_trade_duration?.pnL || [],
    time: performanceChart?.performance_by_trade_duration?.trade_duration || [],
  };
  const trade_Count = {
    data: performanceChart?.trade_count_by_trade_duration?.pnL || [],
    time: performanceChart?.trade_count_by_trade_duration?.trade_duration || [],
  };
  const win_rate = {
    data: performanceChart?.win_rate_by_trade_duration?.win_rate || [],
    time: performanceChart?.win_rate_by_trade_duration?.trade_duration || [],
  };
  const [params, setParams] = useState({
    page: 1,
    page_size: 9,
    active: null,
    platform: null,
  });
  const handleChange = (selectedOption) => {
    setParams((pre) => ({ ...pre, active: selectedOption.value }));
  };

  return (
    <div className="trade-reports">
      {loading && <LoaderOverlay />}
      <div className="header_Wrapper">
        <h2 className="component-heading">Trade Reports</h2>
        {/* <div className="selectorsWrapper">
          <Select
            value={options.find((item) => item.value === params.active)}
            onChange={handleChange}
            isSearchable={false}
            options={options}
            className="react-select-container"
            classNamePrefix="react-select"
            styles={customStyles}
          />
          <Select
            value={options2.find((item) => item.value === params.active)}
            onChange={handleChange}
            isSearchable={false}
            options={options2}
            className="react-select-container"
            classNamePrefix="react-select"
            styles={customStyles}
          />
        </div> */}
      </div>

      <div className="chart-box-wrapper">
        <div className="tabs-wrapper tabs-1">
          <div className="chart-box">
            <h2 className="component-heading">
              Performance By Trade Duration{" "}
              <span className="sub_title"> (Profit vs Time)</span>
            </h2>
            <RoundedBarChart
              color2={"#FF9898"}
              color1={"#8BFB88"}
              data={performance_trade}
              dataSymbol={"amount"}
            />
          </div>
        </div>

        <div className="tabs-wrapper tabs-2">
          <div className="tabs-2-charts">
            <div className="chart-box">
              <h2 className="component-heading">
                Trade Count By Trade Duration{" "}
                <span className="sub_title">(No. of Trades vs Time)</span>
              </h2>
              <RoundedBarChart
                color2={"#FFF27A"}
                color1={"#FFF27A"}
                data={trade_Count}
                dataSymbol={"count"}
              />
            </div>
            <div className="chart-box">
              <h2 className="component-heading">Win Rate By Trade Duration </h2>

              <RoundedBarChart
                color2={"#FF9898"}
                color1={"#8BFB88"}
                data={win_rate}
                dataSymbol={"percentage"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TradeReports;
